import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgxUiLoaderHttpModule } from 'ngx-ui-loader';

import { environment } from 'environments/environment';
import { MottuLoaderModule, MottuNotificationModule } from '@mottu-ops/global-components';
import { MottuTranslateModule, TranslateLoader, translateLoaderFactory } from '@mottu-ops/locale';
import { TranslateStore } from '@ngx-translate/core';
import { HttpInterceptorService } from './interceptors/http/http-interceptor.service';
import { GlobalErrorHandler } from './handlers/global-error.handler';
import { CheckForUpdateService } from './services/check-for-update.service';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		BrowserModule,
		HttpClientModule,
		MottuTranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: translateLoaderFactory([
					{
						prefix: './assets/i18n/',
						suffix: '.json',
					},
				]),
				deps: [HttpClient],
			},
		}),
		MottuLoaderModule.forRoot(),
		MottuNotificationModule.forRoot(),
		NgxUiLoaderHttpModule.forRoot({
			showForeground: true,
			exclude: [`${environment.apiUrl.v3.totemMottuCity}/ListAttendancePanel/`],
		}),
	],
	exports: [BrowserAnimationsModule, BrowserModule, HttpClientModule, MottuLoaderModule, MottuNotificationModule],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true,
		},
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler,
		},
		CheckForUpdateService,
		TranslateStore,
	],
})
export class CoreModule {}
